/*
  How to generate real payment links in Stripe:
  - Go to Stripe Dashboard -> Payment Links -> Create a link
  - Set the price to match each plan
  - Set billing period to monthly, annual, or one-time as appropriate
  - Copy the link and paste it into the matching key in this file
*/

export const STRIPE_LINKS = {
  // Engagement plans — monthly
  basic_monthly:    'https://buy.stripe.com/REPLACE_BASIC_MONTHLY',
  standard_monthly: 'https://buy.stripe.com/REPLACE_STANDARD_MONTHLY',
  pro_monthly:      'https://buy.stripe.com/REPLACE_PRO_MONTHLY',
  agency_monthly:   'https://buy.stripe.com/REPLACE_AGENCY_MONTHLY',
  
  // Engagement plans — annual
  basic_annual:     'https://buy.stripe.com/REPLACE_BASIC_ANNUAL',
  standard_annual:  'https://buy.stripe.com/REPLACE_STANDARD_ANNUAL',
  pro_annual:       'https://buy.stripe.com/REPLACE_PRO_ANNUAL',
  agency_annual:    'https://buy.stripe.com/REPLACE_AGENCY_ANNUAL',
  
  // Karma packages — one-time
  karma_starter:    'https://buy.stripe.com/REPLACE_KARMA_STARTER',
  karma_trust:      'https://buy.stripe.com/REPLACE_KARMA_TRUST',
  karma_power:      'https://buy.stripe.com/REPLACE_KARMA_POWER',
  karma_authority:  'https://buy.stripe.com/REPLACE_KARMA_AUTHORITY',
};
